const useConfirmationPopupData = ({ popupData, closePopup }) => {
  const {
    title = "Confirmation",
    confirmationTitle = "Yes",
    cancelTitle = "Cancel",
    prompt = "",
    onConfirm,
  } = popupData?.item ?? {};

  const handleOnConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }

    closePopup();
  };

  return {
    title,
    confirmationTitle,
    cancelTitle,
    prompt,
    handleOnConfirm,
  };
};

export default useConfirmationPopupData;
